import React from 'react';

import { connect } from 'react-redux';
import { Footer, CreditInfo } from 'ui/lexus/containers';
import { Logo } from 'ui/lexus/outlines';

import styles from './styles';

const {
    MainContainer,
    MainBox,
    MainHeader,
    MainHeaderContainer,
    MainLogo,
    LogoImage,
    GoBack,
    GoBackText,
} = styles;

class Status extends React.Component {
    render() {
        const {
            status: {
                data: {
                    order,
                    order: {
                        merchantOrderNumber,
                    },
                    status,
                    statusDescriprion,
                },
            },
            gotStatusPage,
            error,
            isLoadedStatus,
        } = this.props;
        return (
            <MainContainer>
                <MainHeaderContainer>
                    <MainHeader>
                        Информация о заказе <span>№ {merchantOrderNumber}</span>
                    </MainHeader>
                    <MainLogo><LogoImage src={Logo} /></MainLogo>
                </MainHeaderContainer>
                <MainBox>
                    <CreditInfo
                        order={order}
                        status={status}
                        statusDescriprion={statusDescriprion}
                        gotStatusPage={gotStatusPage}
                        error={error}
                        isLoadedStatus={isLoadedStatus}
                    />

                    <GoBack>
                        <GoBackText>
                            Информация о статусе платежа отправлена на вышеуказанный e-mail
                        </GoBackText>
                    </GoBack>

                </MainBox>
                <Footer status />
            </MainContainer>
        );
    }
}

export default connect(
    state => ({
        status: state.brand.status,
        site: state.brand.site.data,
        dealerCenter: state.brand.dealerCenter,
    }),
    null,
)(Status);
